import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section id="top" className="flex min-h-[calc(100svh-3.75rem)] bg-brand-main px-4 py-7 text-center sm:py-8" data-id="element-86" data-mp="2hvm4m8t8rmbp">
      <motion.div initial={{
      opacity: 0,
      y: 18
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex w-full max-w-4xl flex-col items-center justify-center" data-id="element-87" data-mp="23wmhx6pahhi6">
        <p className="mb-2 text-[10px] font-extrabold tracking-[0.2em] text-brand-teal sm:text-xs" data-id="element-88" data-mp="30lu0q6yixcie">
          IL PROGRAMMA DI MATEMATICA COMPLETO
        </p>
        <h1 className="mx-auto max-w-5xl text-[2.15rem] font-black leading-[1.04] tracking-tight text-brand-blue sm:text-[3.4rem] md:text-[3.75rem]" data-id="element-89" data-mp="2mrtay2pjuzu6">
          Insegna un intero anno di <span className="italic text-brand-purple" data-id="element-90" data-mp="3fh0an50qpvh0">Matematica</span> con soli 5 minuti di
          preparazione
        </h1>
        <p className="mx-auto mt-3 max-w-4xl text-sm leading-relaxed text-brand-gray sm:text-base md:text-lg" data-id="element-91" data-mp="3kb4hloa0a3i3">
          Matematica Pronta è il programma completo e pronto all&apos;uso: 10 volumi con teoria, esempi svolti, esercizi
          graduati e verifiche, dalla classe 1ª primaria al biennio delle superiori. Stampa ed entra in classe.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/ptErDb8AEGMiRBXyTPDzf5/Kit_de_Matematicas_Pronta_para_Docentes-Photoroom.png" alt="Il pacchetto Matematica Pronta con dieci volumi stampabili, materiali digitali e cinque bonus" className="mx-auto my-2 h-[37svh] w-auto max-w-full object-contain sm:my-3 sm:h-[40svh] md:h-[43svh]" data-id="element-92" data-mp="2kdk2t0pbgbc2" />
        <div className="flex w-full flex-col items-center" data-id="element-93" data-mp="334l4hwhtmkzb">
          <CTAButton className="min-w-[204px] px-4 py-2 text-[9px] shadow-sm sm:min-w-[224px] sm:px-5 sm:py-2.5 sm:text-[10px]" data-id="element-94" data-mp="33305nuoh4fvn">
            PRENDI IL PACCHETTO MATEMATICA PRONTA
          </CTAButton>
          <p className="mt-2 max-w-xl text-center text-[9px] font-semibold leading-relaxed text-brand-gray sm:text-[10px]" data-id="element-95" data-mp="18t68wz24prbn">
            ✓ Download digitale immediato <span className="px-1 text-brand-orange" data-id="element-96" data-mp="3dth2r9ubdx74">·</span> ✓ Dalla 1ª primaria al
            biennio <span className="px-1 text-brand-orange" data-id="element-97" data-mp="3ir94swooazp1">·</span> ✓ Allineato alle Indicazioni Nazionali
          </p>
        </div>
      </motion.div>
    </section>;
}